import React, { useEffect } from "react";
import { ListContextProvider, useListContext } from "react-admin";
import { useHistory } from "react-router-dom";
import CustomLinearProgress from "../../../../../Components/Progress/LinearProgress";
import { EightWingsStatus } from "../../../../../Enums/EightWingsTabEnum";
import OpenRequestsDataGrid from "./OpenDataGrid/OpenRequestsDataGrid";
import InProgressDataGrid from "./InProgressDataGrid/InProgressDataGrid";
import PlannedToDeliveryDataGrid from "./PlannedToDeliveryDataGrid/PlannedToDeliveryDataGrid";
import WaitingTTVerifyDataGrid from "./WaitingTTVerifyDataGrid/WaitingTTVerifyDataGrid";

export const DataGrid = props => {
  const listContext = useListContext();
  const history = useHistory();
  const { record, requestStatus, setActiveTab, createId, reloadTabs, ...rest } = props;
  const { ids, filterValues, setFilters, displayedFilters, loading, data } = listContext;
  useEffect(() => {
    if (requestStatus == EightWingsStatus.WaitingTTVerify) {
      setFilters(
        { status__in: [EightWingsStatus.WaitingTTVerify, EightWingsStatus.ServiceableDelivered] },
        displayedFilters
      );
    } else {
      setFilters({ status__eq: requestStatus }, displayedFilters);
    }
  }, [requestStatus]);

  return (
    <ListContextProvider
      {...rest}
      value={{
        ...listContext,
        ids: ids,
      }}
    >
      <CustomLinearProgress loading={loading} periodTime={500} />
      {!loading && requestStatus === EightWingsStatus.Open && (
        <OpenRequestsDataGrid {...props} reloadTabs={reloadTabs} />
      )}
      {!loading && requestStatus === EightWingsStatus.InProgress && (
        <InProgressDataGrid {...props} reloadTabs={reloadTabs} />
      )}
      {!loading && requestStatus === EightWingsStatus.PlannedToDelivery && (
        <PlannedToDeliveryDataGrid {...props} reloadTabs={reloadTabs} />
      )}
      {!loading && requestStatus === EightWingsStatus.WaitingTTVerify && (
        <WaitingTTVerifyDataGrid {...props} reloadTabs={reloadTabs} />
      )}
    </ListContextProvider>
  );
};

export default DataGrid;
